<div (click)="triggerView()"
  class="grid grid-cols-12 gap-x-3 px-5 py-3.5 border-b border-slate-100 dark:border-slate-700/50 hover:bg-blue-50/40 hover:shadow-[inset_3px_0_0_#0D76BA] transition-all duration-150 text-[11px] items-center cursor-pointer group">

  <!-- col-span-1: Date -->
  <div class="col-span-1 text-left">
    <p class="text-slate-900 dark:text-white font-bold leading-tight">{{ (loan().created_at || loan().createdAt) | date: 'dd MMM' }}</p>
    <p class="text-slate-400 text-[10px] uppercase font-medium">{{ (loan().created_at || loan().createdAt) | date: 'yyyy' }}</p>
  </div>

  <!-- col-span-2: Applicant -->
  <div class="col-span-2 flex items-center justify-start gap-2">
    <div class="w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 text-white text-[10px] font-bold uppercase bg-primary-800">
      {{ loan().user?.firstName?.charAt(0) || '' }}{{ loan().user?.lastName?.charAt(0) || '' }}
    </div>
    <div class="min-w-0 text-left">
      <div class="flex items-center gap-1.5 flex-wrap">
        <p class="text-slate-900 dark:text-white font-bold leading-tight group-hover:text-primary-800 dark:text-primary-400 transition-colors">{{ loan().user?.firstName }} {{ loan().user?.lastName }}</p>
        @if (loan().counterOffer) {
        <span class="inline-flex items-center gap-1 text-[9px] font-bold px-1.5 py-0.5 rounded-full bg-amber-100 text-amber-600 border border-amber-300 uppercase tracking-wide flex-shrink-0">
          <svg class="w-2.5 h-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
          </svg>
          Counter
        </span>
        }
      </div>
      <p class="text-slate-400 text-[10px]">{{ loan().user?.email || '—' }}</p>
    </div>
  </div>

  <!-- col-span-2: ID / Card -->
  <div class="col-span-2 text-left">
    <p class="text-slate-900 dark:text-white font-bold leading-tight">{{ loan().reference?.substring(0, 12) }}...</p>
    <p class="text-slate-400 text-[10px] font-mono tracking-tighter">{{ loan().userGhanaCard ||
      loan().user?.ghanaCardNumber || 'NO ID' }}</p>
  </div>

  <!-- col-span-1: Applied -->
  <div class="col-span-1 text-left">
    <p class="text-slate-900 dark:text-white font-bold leading-tight">{{ (loan().created_at || loan().createdAt) | date: 'dd MMM' }}</p>
    <p class="text-slate-400 text-[10px] uppercase font-medium">{{ (loan().created_at || loan().createdAt) | date: 'yyyy' }}</p>
  </div>

  <!-- col-span-1: Principal -->
  <div class="col-span-1 text-left">
    <p class="text-slate-900 dark:text-white font-bold">₵{{ loan().amount | number:'1.0-0' }}</p>
  </div>

  <!-- col-span-1: Interest -->
  <div class="col-span-1 text-left">
    <p class="text-slate-500 dark:text-slate-400 font-medium">₵{{ loan().interest | number:'1.0-0' }}</p>
  </div>

  <!-- col-span-1: Repayment -->
  <div class="col-span-1 text-left">
    <p class="text-primary-800 dark:text-primary-400 font-bold">₵{{ loan().totalRepayment | number:'1.0-0' }}</p>
  </div>

  <!-- col-span-1: Tenure -->
  <div class="col-span-1 text-left font-bold text-slate-700 dark:text-slate-300">
    {{ loan().tenure }}<span class="text-[9px] text-slate-400 font-medium ml-0.5">{{ loan().product?.tenureType === 'DAILY' ? 'D' : 'M' }}</span>
  </div>

  <!-- col-span-1: Status -->
  <div class="col-span-1 flex justify-start">
    <div class="flex flex-col items-start gap-0.5">
      <span class="text-xs font-bold px-2.5 py-1 rounded-md uppercase tracking-normal whitespace-nowrap border"
        [class]="loan().status | loanStatusStyle">
        {{ loan().status | loanStatusLabel }}
      </span>
      @if (loan().status === 'REJECTED' && loan().counterOffer) {
      <span class="text-[9px] font-semibold text-rose-500 leading-tight">After counter offer</span>
      }
    </div>
  </div>

  <!-- col-span-1: Actions -->
  <div class="col-span-1 flex justify-center" (click)="$event.stopPropagation()">
    <button (click)="triggerView()"
      class="px-2 py-1 text-xs font-semibold text-slate-600 dark:text-slate-400 border border-slate-200 dark:border-slate-700 rounded hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 hover:border-slate-300 dark:border-slate-600 transition-colors">
      View
    </button>
  </div>
</div>